export const LG = "(min-width: 1200px)";